import React from 'react';
import { Link } from 'react-router-dom';
import UserDashboardLayout from '../../components/dashboard/UserDashboardLayout';
import { useAuth } from '../../context/AuthContext';

export default function TenantDashboard() {
    const { user } = useAuth();

    return (
        <UserDashboardLayout>
            <div className="flex flex-col md:flex-row items-center justify-between mb-10">
                <div>
                    <h2 className="text-3xl font-black text-slate-900 mb-2">Welcome Back, {user?.name?.split(' ')[0]}!</h2>
                    <p className="text-slate-500 font-medium">Manage your rental experience effortlessly from your new dashboard.</p>
                </div>
                <div className="mt-6 md:mt-0 flex gap-4">
                    <Link to="/project-list?listingType=For Rent" className="bg-emerald-600 text-white px-8 py-3.5 rounded-2xl font-bold hover:shadow-xl transition-all shadow-emerald-200 shadow-lg flex items-center gap-2">
                        <i className="fa-solid fa-search-location"></i> Find Rentals
                    </Link>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
                <div className="bg-white p-6 rounded-3xl shadow-sm border border-slate-100 group">
                    <div className="w-14 h-14 bg-emerald-50 text-emerald-600 rounded-2xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                        <i className="fa-regular fa-paper-plane text-2xl"></i>
                    </div>
                    <h3 className="text-3xl font-black text-slate-800 mb-1">2</h3>
                    <p className="text-xs font-bold text-slate-400 uppercase tracking-widest">Active Applications</p>
                </div>

                <div className="bg-white p-6 rounded-3xl shadow-sm border border-slate-100 group">
                    <div className="w-14 h-14 bg-amber-50 text-amber-600 rounded-2xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                        <i className="fa-regular fa-calendar text-2xl"></i>
                    </div>
                    <h3 className="text-3xl font-black text-slate-800 mb-1">0</h3>
                    <p className="text-xs font-bold text-slate-400 uppercase tracking-widest">Pending Payments</p>
                </div>

                <div className="bg-white p-6 rounded-3xl shadow-sm border border-slate-100 group">
                    <div className="w-14 h-14 bg-rose-50 text-rose-600 rounded-2xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                        <i className="fa-solid fa-screwdriver-wrench text-2xl"></i>
                    </div>
                    <h3 className="text-3xl font-black text-slate-800 mb-1">0</h3>
                    <p className="text-xs font-bold text-slate-400 uppercase tracking-widest">Maintenance Tickets</p>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div className="bg-white rounded-[2rem] shadow-sm border border-slate-100 p-8">
                    <h4 className="text-xl font-bold text-slate-800 mb-6 border-b border-slate-50 pb-4">Current Lease Overview</h4>
                    <div className="text-center py-10 opacity-40">
                        <i className="fa-solid fa-file-signature text-5xl text-slate-200 mb-4"></i>
                        <p className="font-bold text-slate-400">No active lease connected to your account.</p>
                    </div>
                </div>
                
                <div className="bg-white rounded-[2rem] shadow-sm border border-slate-100 p-8">
                    <h4 className="text-xl font-bold text-slate-800 mb-6 border-b border-slate-50 pb-4">Saved Rentals</h4>
                    <div className="text-center py-10 opacity-40">
                        <i className="fa-regular fa-bookmark text-5xl text-slate-200 mb-4"></i>
                        <p className="font-bold text-slate-400">You haven't saved any rental properties yet.</p>
                    </div>
                </div>
            </div>
        </UserDashboardLayout>
    );
}
